var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-block d-sm-none text-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.h2)))]),_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.h1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }